import { ComponentPropsWithoutRef, ReactNode } from 'react'

export interface AuthCheckboxProps
  extends Pick<
    ComponentPropsWithoutRef<'input'>,
    'checked' | 'onChange' | 'onBlur'
  > {
  label: ReactNode | string
  error?: string
  labelClassName?: string
}
